import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    hr: {
      borderTop: `solid 1px ${legacyColors.grey4}`,
    },
    table: {
      borderCollapse: 'collapse',
    },
    thDate: {
      width: '110px',
      minWidth: '110px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thPerf: {
      width: '130px',
      minWidth: '130px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thComment: {
      width: '500px',
      minWidth: '500px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    td: {
      textAlign: 'left',
      fontSize: '13px',
    },
    chart: {
      height: '300px',
      psotion: 'relative',
      fontSize: '15px',
    },
  };
};
